import { UpdatedPassword, UserProfile, UserProfileUpdated } from 'hooks/useProfile';
import { RubricaeService } from './rubricaeService';

export class profileService {
    public static async getProfileData() {
        return (await RubricaeService.get('/user/profile')).data as UserProfile;
    }

    public static async updateProfileData(profile: UserProfileUpdated | UpdatedPassword) {
        return (await RubricaeService.put('/user/profile', profile)).data as UserProfile;
    }

    public static async addGrafSign() {
        return (await RubricaeService.post('/user/graphometric-signature')).data as UserProfile;
    }

    public static async updateSmsConfig(id: string, body: any) {
        return (await RubricaeService.post(`/user/update-sms-config/${id}`, body)).data as UserProfile;
    }

    public static async updateEmailConfig(id: string, body: any) {
        return (await RubricaeService.post(`/user/update-email-config/${id}`, body)).data as UserProfile;
    }
}
